import { INewQuoteForm, ITimeQuote, ITravelPointQuote } from '../schema'
import { IBasicInquiryLoadLite, IBasicUser, IPackagingType, IPlaceQuote } from '../types'
import { getUtcDate } from './date.ts'

export const defaultTime = (): ITimeQuote => ({
  from: '8:00',
  to: '16:00',
  type: 'between',
})

export const defaultDrops = (
  order: number,
  location?: IPlaceQuote,
  date?: string,
  time?: ITimeQuote,
): Partial<ITravelPointQuote> => ({
  date: date ? getUtcDate(new Date(date)).toISOString() : undefined,
  order,
  place: location,
  time: time ? { type: 'between', ...time } : defaultTime(),
  type: order === 0 ? 'collection' : 'delivery',
})

export type INewQuoteParams = Pick<
  IBasicInquiryLoadLite['load'],
  | 'destination'
  | 'drops'
  | 'id'
  | 'load_date'
  | 'load_type'
  | 'notes'
  | 'origin'
  | 'pallets'
  | 'unload_date'
  | 'weight'
> & { isEdit?: boolean } & {
  load_time: ITimeQuote
  packaging_type: IPackagingType
  unload_time: ITimeQuote
}

interface IProps {
  isAdmin?: boolean
  params?: INewQuoteParams
  showDate?: boolean
  user?: Partial<IBasicUser>
}

export const defaultQuote = ({
  isAdmin,
  params,
  showDate = false,
  user,
}: IProps): Partial<INewQuoteForm> => {
  return {
    company_id: isAdmin ? 0 : user?.company?.id! || 1, // eslint-disable-line
    drops: [
      defaultDrops(
        0,
        params?.origin && {
          ...params.origin,
          country: params.origin.country_code || params.origin.country,
        },
        showDate ? params?.load_date : undefined,
        showDate ? params?.load_time : undefined,
      ) as ITravelPointQuote,
      defaultDrops(
        1,
        params?.destination && {
          ...params.destination,
          country: params.destination.country_code || params.destination.country,
        },
        showDate ? params?.unload_date : undefined,
        showDate ? params?.unload_time : undefined,
      ) as ITravelPointQuote,
    ],
    goods: [], // Skad to wziac ?
    load_type_id: params?.load_type?.id ?? 1,
    notes: params?.notes ?? '', // Do zrobienia
    packaging_type_id: 1, // Do zrobienia
    pallets: params?.pallets ?? 26,
    requirements: { adr: false, dvs: false, waste_license: false }, // Skad to wziac ?
    temperature: undefined,
    user_id: isAdmin ? 0 : user?.id || 0,
    weight: params?.weight ?? '0 t',
  }
}
